import React, { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import withBackUrl, { WithBackUrlProps } from '../../withBackUrl';

function BackButton({ backUrl, isBackUrlRelative, isGoBackHistory }: WithBackUrlProps) {

  const history = useHistory();

  const goBack = useCallback((e) => {
    if (isGoBackHistory) {
      e.preventDefault();
      history.go(-1);
    }
  }, [history, isGoBackHistory]);

  return isBackUrlRelative ? (
    <Link
      to={backUrl}
      onClick={goBack}
      className="mio-sub-nav__back-button mio-text-link color-secondary cursor-pointer"
    >
      <i className="iconfont icon-back vertical-middle" />
    </Link>
  ) : (
    <a
      href={backUrl}
      onClick={goBack}
      className="mio-sub-nav__back-button mio-text-link color-secondary cursor-pointer"
    >
      <i className="iconfont icon-back vertical-middle" />
    </a>
  );
}

BackButton.defaultProps = {
  backUrl: '/',
} as Partial<WithBackUrlProps>;

export default withBackUrl(BackButton);
